import { render, staticRenderFns } from "./addtest.vue?vue&type=template&id=0efbb383&scoped=true&"
import script from "./addtest.vue?vue&type=script&lang=js&"
export * from "./addtest.vue?vue&type=script&lang=js&"
import style0 from "./addtest.vue?vue&type=style&index=0&id=0efbb383&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efbb383",
  null
  
)

export default component.exports